import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { setUser } from "../features/userSlice";
import { Navigate, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import C_Navbar from "./C_Navbar";
import axios from "axios";
import ENV from "../env";

const SearchEmail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.userInfo);
  const [query, setQuery] = useState("");
  const [result, setResult] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const isDev = ENV.MODE === "dev";

  useEffect(() => {
    if (!user) {
      const saved = localStorage.getItem("token");
      if (saved) {
        try {
          const { token } = JSON.parse(saved);
          const decoded = jwtDecode(token);

          const isExpired = decoded.exp * 1000 < Date.now(); // JWT exp 是秒，要乘1000變成毫秒

          if (isExpired) {
            console.warn("⏰ token 已過期，登出中...");
            localStorage.removeItem("token");
            navigate("/", { replace: true });
            return;
          }

          if (decoded && decoded.email && decoded.name) {
            dispatch(setUser({ ...decoded, token }));
            return;
          }
        } catch (err) {
          console.warn("❌ token 無效，將導向 /");
        }
      }

      navigate("/", { replace: true });
    }
  }, [user, dispatch, Navigate]);

  const handleInputChange = (e) => {
    setQuery(e.target.value);
  };

  const handleSearch = async () => {
    const saved = localStorage.getItem("token");
    if (!saved) return alert("未登入");

    const { token } = JSON.parse(saved);
    setIsLoading(true); // 🌀 開始 loading

    try {
      const response = await axios.post(
        `${isDev ? ENV.BACKEND_URL_DEV : ENV.BACKEND}/api/user/search`,
        { item: query },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      //sleep for 5s
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setResult(response.data);
    } catch (err) {
      console.error("❌ 搜尋錯誤", err);
      alert("搜尋失敗，請確認格式與權限");
    } finally {
      setIsLoading(false); // ✅ 結束 loading
    }
  };

  return (
    <section className="searchemail">
      <C_Navbar />

      <div className="searchemail-container">
        <h2>🔍 請輸入 帳號 或者 身分證字號 進行搜尋：</h2>
        <input
          type="text"
          placeholder="輸入 帳號 或者 身分證字號"
          value={query}
          onChange={handleInputChange}
          className="searchemail-container-input"
        />

        {isLoading ? (
          <div className="searchemail-container-loading">
            <div className="spinner"></div>
            <p>搜尋中...</p>
          </div>
        ) : (
          <button
            onClick={handleSearch}
            className="searchemail-container-button"
          >
            搜尋
          </button>
        )}

        {query && (
          <p className="searchemail-container-preview">目前搜尋內容：{query}</p>
        )}

        {result && !isLoading && (
          <div
            className={`searchemail-container-result ${
              result?.status === "success" ? "success" : "error"
            }`}
          >
            <h3>搜尋結果：</h3>

            <pre>{result.message}</pre>

            {result.status === "success" && result.data && (
              <a
                href={result.data}
                target="_blank"
                rel="noopener noreferrer"
                className="searchemail-container-link"
              >
                🔗 前往驗證網址
              </a>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default SearchEmail;
